import { cn } from '../../../lib/utils';

// Canonical field recipe (same as the profile/Create Group forms): 13px label,
// idle input — gray-50, 0.5px white stroke, hover white.
export const FIELD_LABEL_CLASS = 'text-[13px] leading-5 text-black dark:text-neutral-100';

export const FIELD_INPUT_CLASS = cn(
  'h-12 w-full rounded-lg border-[0.5px] border-white bg-gray-50 px-4 text-[15px] leading-5 text-black placeholder:text-gray-400',
  'outline-none hover:bg-white focus:border-gray-400',
  'dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-100 dark:placeholder:text-neutral-500',
);

// Canonical blue pill submit — same recipe as the settings modals' Save pill
// (settingsModalChrome's SETTINGS_MODAL_SAVE_PILL_CLASS), but padded width
// instead of the fixed w-15 because "Update" doesn't fit 60px.
export const FIELD_SUBMIT_BUTTON_CLASS =
  'flex h-9 shrink-0 cursor-pointer items-center justify-center rounded-full bg-idle-blue px-4 text-sm leading-[18px] font-medium text-white hover:opacity-90 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500 dark:disabled:bg-neutral-800 dark:disabled:text-neutral-500';

export const FIELD_INPUT_ERROR_CLASS = 'border-red-300 dark:border-red-400/40';

export const firstFieldError = (value) => (Array.isArray(value) ? value.join(', ') : value);

// Field-level validation errors from an API envelope, or null when none are present.
export const responseValidations = (data) =>
  data?.validations && Object.keys(data.validations).length > 0 ? data.validations : null;
